import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createOrder = (payload) => api.post("/orders", payload).then((r) => r.data);
export const verifyPayment = (payload) => api.post("/orders/verify", payload).then((r) => r.data);
export const getConfig = () => api.get("/config").then((r) => r.data);
export const validateCoupon = (code, payment_method, quantity = 1) =>
  api.post("/coupons/validate", { code, payment_method, quantity }).then((r) => r.data);

// -------- Admin --------
export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => r.data);

export const adminGetOrders = (password) =>
  api
    .get("/admin/orders", { headers: { "X-Admin-Password": password } })
    .then((r) => r.data);

export const adminExportCsv = async (password) => {
  const res = await api.get("/admin/orders/export.csv", {
    headers: { "X-Admin-Password": password },
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
  const link = document.createElement("a");
  link.href = url;
  const stamp = new Date().toISOString().replace(/[:.]/g, "-").slice(0, 19);
  link.download = `bajrangveda_orders_${stamp}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const adminUpdateStatus = (password, orderId, status) =>
  api
    .patch(`/admin/orders/${orderId}`, { status }, { headers: { "X-Admin-Password": password } })
    .then((r) => r.data);

// Coupons (admin)
export const adminListCoupons = (password) =>
  api.get("/admin/coupons", { headers: { "X-Admin-Password": password } }).then((r) => r.data);
export const adminCreateCoupon = (password, payload) =>
  api.post("/admin/coupons", payload, { headers: { "X-Admin-Password": password } }).then((r) => r.data);
export const adminUpdateCoupon = (password, code, updates) =>
  api.patch(`/admin/coupons/${code}`, updates, { headers: { "X-Admin-Password": password } }).then((r) => r.data);
export const adminDeleteCoupon = (password, code) =>
  api.delete(`/admin/coupons/${code}`, { headers: { "X-Admin-Password": password } }).then((r) => r.data);

// Analytics (admin)
export const adminAnalytics = (password) =>
  api.get("/admin/analytics", { headers: { "X-Admin-Password": password } }).then((r) => r.data);
